//@flow
import env from '../../../environment';
import {
  getCreator,
  postCreator,
  deleteCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  GET_STORE_LOCATION: `${env.baseApiUrl}/ui/admin/store/store-location/:locationId`,
  LIST_STORE_LOCATIONS: `${env.baseApiUrl}/ui/admin/store/store-location`,
  CREATE_STORE_LOCATION: `${env.baseApiUrl}/ui/admin/store/store-location`,
  UPDATE_STORE_LOCATION: `${env.baseApiUrl}/ui/admin/store/store-location/:locationId`,
  DELETE_STORE_LOCATION: `${env.baseApiUrl}/ui/admin/store/store-location/:locationId`,
});

export const getStoreLocationApi = getCreator(endpoints.GET_STORE_LOCATION);
export const listStoreLocationsApi = getCreator(endpoints.LIST_STORE_LOCATIONS);
export const createStoreLocationApi = postCreator(
  endpoints.CREATE_STORE_LOCATION
);
export const updateStoreLocationApi = putCreator(
  endpoints.UPDATE_STORE_LOCATION
);
export const deleteStoreLocationApi = deleteCreator(
  endpoints.DELETE_STORE_LOCATION
);
